import { useState, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import { useSelector } from "react-redux";
import * as dropdown from "../dropdowns";
import { Bell, Search, ShoppingCart } from "lucide-react";

function DesktopNav({ isAuthenticated, handleLogout, loggingOut }) {
  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const wrapperRef = useRef(null);

  const cartItems = useSelector((state) => state.cart.cartItems || []);
  const cartCount = cartItems.length;

  // const triggerSearch = () => {
  //   const trimmedSearchTerm = searchTerm.trim();
  //   if (trimmedSearchTerm) {
  //     const newUrl = `/products?searchTerm=${encodeURIComponent(trimmedSearchTerm)}`;
  //     window.location.href = newUrl; // Force page reload with new parameters
  //     setSearchTerm(''); // Clear the search term after navigation
  //     setShowSearch(false); // Hide the search bar
  //   }
  // };

  const triggerSearch = () => {
    const trimmedSearchTerm = searchTerm.trim();
    if (trimmedSearchTerm) {
      const timestamp = new Date().getTime(); // Add a unique timestamp
      const newUrl = `/products?searchTerm=${encodeURIComponent(
        trimmedSearchTerm
      )}&timestamp=${timestamp}`;
      navigate(newUrl, { replace: true }); // Update the URL
      setSearchTerm(""); // Clear the search term after navigation
      setShowSearch(false); // Hide the search bar
    }
  };

  const handleInputKeyPress = (e) => {
    if (e.key === "Enter") {
      triggerSearch();
    }
    if (e.key === "Escape") {
      setShowSearch(false);
    }
  };

  return (
    <nav className="navbar-custom hidden lg:flex px-5 h-[12vh] overflow-y-visible">
      <div className="container mx-auto flex items-center justify-between gap-2 py-2">
        <NavLink
          className="navbar-brand hover:scale-110 transition-transform ease-in-out duration-300"
          to={isAuthenticated ? "/home" : "/"}
        >
          <img loading="lazy" src={logo} alt="logo" className="pb-2 h-28" />
        </NavLink>

        <div className="navbar-links flex items-center space-x-8">
          <NavLink
            to={isAuthenticated ? "/home" : "/"}
            className={({ isActive }) =>
              `px-3 py-1 rounded-3xl font-semibold transition-colors ${
                isActive ? "bg-normal-theme-color text-white" : "text-black"
              } hover:bg-normal-theme-color hover:text-white`
            }
          >
            Home
          </NavLink>
          <dropdown.CategoriesDropdown />
          {isAuthenticated && (
            <NavLink
              to="/wishlist"
              className={({ isActive }) =>
                `px-3 py-1 rounded-3xl font-semibold transition-colors ${
                  isActive ? "bg-normal-theme-color text-white" : "text-black"
                } hover:bg-normal-theme-color hover:text-white`
              }
            >
              Wishlist
            </NavLink>
          )}
          {isAuthenticated ? (
            <dropdown.MyAccDropdown
              handleLogout={handleLogout}
              loggingOut={loggingOut}
            />
          ) : (
            <NavLink
              to="/login"
              className={({ isActive }) =>
                `nav-link font-semibold px-3 py-1 ${
                  isActive
                    ? "bg-normal-theme-color text-white rounded-ee-md rounded-3xl"
                    : ""
                }`
              }
            >
              Login
            </NavLink>
          )}
        </div>

        <div className="relative flex items-center space-x-4">
          {isAuthenticated && (
            <NavLink
              to="/notifications"
              className={({ isActive }) =>
                `nav-link text-lg lg:text-xl ${
                  isActive
                    ? "bg-medium-theme-color text-white rounded-ee-md rounded-3xl px-2 py-1"
                    : ""
                }`
              }
            >
              <Bell strokeWidth={2.75} className="size-5" />
            </NavLink>
          )}

          {isAuthenticated && (
            <div className="relative">
              <NavLink
                to="/cart"
                className={({ isActive }) =>
                  `nav-link text-lg lg:text-xl ${
                    isActive
                      ? "bg-medium-theme-color text-white rounded-ee-md rounded-3xl px-2 py-1"
                      : ""
                  }`
                }
              >
                <ShoppingCart strokeWidth={2.75} className="size-5" />
                {isAuthenticated && cartCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                    {cartCount}
                  </span>
                )}
              </NavLink>
            </div>
          )}

          {/* Global Search */}
          <div
            ref={wrapperRef}
            className="relative flex items-center space-x-2"
          >
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={handleInputKeyPress}
              placeholder="Search..."
              className={`transition-all duration-300 ease-in-out w-0 ${
                showSearch
                  ? "w-64 px-3 py-1 border rounded-md outline-none"
                  : ""
              }`}
            />

            <button
              onClick={() => {
                if (showSearch && searchTerm) triggerSearch();
                else {
                  setSearchTerm("");
                  setShowSearch((prev) => !prev);
                }
              }}
              className="text-xl"
              aria-label="Toggle Search"
            >
              <Search strokeWidth={2.75} className="size-5" />
            </button>
          </div>

          {!isAuthenticated && <dropdown.BecomeAPartner />}
        </div>
      </div>
    </nav>
  );
}

export default DesktopNav;
